import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import ConfirmationModal from './ConfirmationModal';
import { useFeedbackModal } from './common/useFeedbackModal';

// Normalize to backend codes: 'en', 'am', or 'om'
const normalizeLanguage = (lng) => {
  if (!lng || typeof lng !== 'string') return 'en';
  const lower = lng.trim().toLowerCase();
  if (lower.startsWith('am') || lower === 'amharic') return 'am';
  if (lower.startsWith('om') || lower === 'oromo') return 'om';
  return 'en';
};

function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const { modal, openModal, closeModal } = useFeedbackModal();

  const changeLanguage = async (lng) => {
    const normalized = normalizeLanguage(lng);
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
      const response = await axios.get(`${apiUrl}/localization/messages?language=${normalized}`);
      const raw = response.data;
      const messages = (raw && typeof raw === 'object' && raw.data && typeof raw.data === 'object')
        ? raw.data
        : (raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {});
      const count = Object.keys(messages).length;
      if (count === 0) {
        console.warn('No translations received for', normalized);
        openModal({
          title: t('language.translationFailed'),
          message: t('language.translationFailedMessage'),
          type: 'error'
        });
        return;
      }
      i18n.addResourceBundle(normalized, 'translation', messages, true, true);
      await i18n.changeLanguage(normalized);
      window.dispatchEvent(new Event('i18n-language-changed'));
    } catch (error) {
      console.error('Error changing language:', error);
      openModal({
        title: t('language.translationFailed'),
        message: t('language.translationFailedMessage'),
        type: 'error'
      });
    }
  };

  return (
    <div className="language-switcher">
      <select
        value={normalizeLanguage(i18n.language) || 'en'}
        onChange={(e) => changeLanguage(e.target.value)}
        aria-label={t('language.label')}
      >
        <option value="en">{t('language.english')}</option>
        <option value="am">{t('language.amharic')}</option>
        <option value="om">{t('language.oromo')}</option>
      </select>

      <ConfirmationModal
        isOpen={modal.isOpen}
        onClose={closeModal}
        onConfirm={() => {}}
        title={modal.title}
        message={modal.message}
        type={modal.type}
        confirmText={t('common.ok')}
        cancelText=""
      />
    </div>
  );
}

export default LanguageSwitcher;
